<template>
    <footer class="footer-wrapper">
        <div class="footer-container">
            <div class="container-xl d-flex">
                <section class="footer-container__subtitle col-8">
                    <h2>les architectes du projet</h2>
                </section>
                <section class="footer-container__contact-title col-4">
                    <h2>nous contacter</h2>
                </section>
            </div>
        </div>
        <div class="footer-container">
            <div class="container-xl d-flex">
                <section class="footer-container__partners col-8">
                    <div v-for="[title, image, key] in partners"
                         :key="key">
                        <a :href="image.link"
                           class="img-container pe-1 d-flex-column-center"
                           target="_blank"
                           :title="title">
                            <img :src="image.src"
                                 :alt="title"
                                 width="200px"
                                 height="100px" />
                        </a>
                    </div>
                </section>
                <section class="footer-container__contact col-4">
                    <ul class="clean-ul">
                        <li>870, avenue de Salaberry, bureau R35</li>
                        <li>Québec (QC) G1R 2T9</li>
                        <li>Téléphone : <a href="tel:+14188001144">(418) 800-1144</a></li>
                        <li>
                            <a href="https://www.robvq.qc.ca"
                               class="text-green"
                               target="_blank">
                                www.robvq.qc.ca
                            </a>
                        </li>
                    </ul>
                </section>
            </div>
        </div>
        <div class="footer-container">
            <div class="container-xl d-flex">
                <section class="footer-container__footer col-12">
                    &#169; ROBVQ {{ currentYearCopyright }} Tous droits réservés -
                    Conception et design par
                    <a class="text-white"
                       target="_blank"
                       href="https://infernal.studio">
                        Infernal&nbsp;[&thinsp;Studio&thinsp;]
                    </a>
                </section>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            partners: new Map([
                [
                    'ROBVQ',
                    {
                        src: '/images/ROBVQ_logo.png',
                        link: 'https://www.robvq.qc.ca',
                    },
                ],
                [
                    'MELCC',
                    {
                        src: '/images/PEV_Couleurs_couleurs.png',
                        link: 'https://www.environnement.gouv.qc.ca/plan-economie-verte/bref.htm',
                    },
                ],
                [
                    'UBLO',
                    {
                        src: '/images/UBLO_LOGO_COUL.png',
                        link: 'https://lesateliersublo.com',
                    },
                ],
            ]),
        }
    },
    computed: {
        currentYearCopyright() {
            const startYear = 2022
            const currentYear = this.$date().year()
            if (currentYear === startYear) {
                return startYear
            }
            return `${startYear}-${currentYear}`
        },
    },
}
</script>
<style lang="scss" scoped>
.footer-wrapper {
    display: grid;
    grid-auto-columns: 100vw;
    grid-template-rows: 1fr auto 1fr;

    .footer-container:nth-child(odd) {
        width: 100%;
        background-color: var(--bs-primary);
        color: var(--bs-white);
    }

    .footer-container:nth-child(even) {
        padding: 4% 0;
    }
}

.footer-container {
    --padding: 1.25rem 0;

    &__subtitle {
        padding: var(--padding);
    }

    &__contact-title {
        padding: var(--padding);
        text-align: right;
        position: relative;

        &:after {
            display: block;
            content: url('../../images/arrow.svg');
            position: absolute;
            right: 0;
            --IMG_SIZE: 11%;
            bottom: calc(-1 * var(--IMG_SIZE));
            height: var(--IMG_SIZE);
            width: var(--IMG_SIZE);
        }
    }

    &__contact {
        ul>li {
            text-align: right;
            color: var(--bs-primary);

            &:last-child {
                padding: 1em 0;

                a {
                    color: var(--bs-green);
                }
            }
        }
    }

    &__footer {
        padding: var(--padding);
    }

    &__partners {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        grid-template-rows: 120px;

        img {
            height: 120px;
            object-fit: contain;
        }
    }

    h2 {
        font-weight: 500;
        text-transform: uppercase;
        font-size: 1.44rem;
    }
}
</style>
